import { BookOpen } from 'lucide-react';
import {
  Dialog,
  DialogTrigger,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from './ui/dialog';
import { Badge } from './ui/badge';
import { Button } from './ui/button';
import { ANOMALY_RULES, type RuleSeverity } from '../lib/anomaly-rules';

const SEVERITY_META: Record<
  RuleSeverity,
  { variant: 'destructive' | 'warning' | 'info'; label: string }
> = {
  high: { variant: 'destructive', label: 'Nghiêm trọng' },
  medium: { variant: 'warning', label: 'Trung bình' },
  low: { variant: 'info', label: 'Thấp' },
  mixed: { variant: 'warning', label: 'TB → Cao' },
};

/** Header action that opens a reference explaining what each alert rule (R1–R9) does. */
export function RuleReferenceDialog() {
  return (
    <Dialog>
      <DialogTrigger asChild>
        <Button variant="secondary" className="inline-flex items-center gap-1.5">
          <BookOpen size={14} strokeWidth={1.5} />
          Giải thích rule
        </Button>
      </DialogTrigger>
      <DialogContent className="max-w-2xl">
        <DialogHeader>
          <DialogTitle>Quy tắc cảnh báo (R1–R9)</DialogTitle>
          <DialogDescription>
            Logic phát hiện và ngưỡng mặc định của từng rule. Ngưỡng có thể được điều chỉnh theo cấu
            hình thực tế.
          </DialogDescription>
        </DialogHeader>

        <div className="-mx-2 max-h-[60vh] space-y-3 overflow-y-auto px-2">
          {ANOMALY_RULES.map((rule) => {
            const sev = SEVERITY_META[rule.severity];
            return (
              <div
                key={rule.code}
                className={`rounded-lg border border-border p-3 ${rule.active ? 'bg-card' : 'bg-muted/40'}`}
              >
                <div className="mb-1.5 flex flex-wrap items-center gap-2">
                  <span className="font-mono text-sm font-semibold text-foreground">
                    {rule.code}
                  </span>
                  <span className="text-sm font-medium text-foreground">{rule.name}</span>
                  <span className="ml-auto flex items-center gap-1.5">
                    <Badge variant={sev.variant}>{sev.label}</Badge>
                    {!rule.active && <Badge variant="secondary">Chưa kích hoạt</Badge>}
                  </span>
                </div>
                <p className="text-sm text-muted-foreground">{rule.trigger}</p>
                <div className="mt-2 flex flex-wrap gap-1.5">
                  {rule.defaults.map((d) => (
                    <span
                      key={d}
                      className="rounded border border-border bg-background px-1.5 py-0.5 text-xs tabular-nums text-muted-foreground"
                    >
                      {d}
                    </span>
                  ))}
                </div>
              </div>
            );
          })}
        </div>
      </DialogContent>
    </Dialog>
  );
}
